
const SkipButton = ({ handleClick, text }: {
  handleClick: () => void,
  text: string
}) => {
  return (
     <button
        onClick={handleClick}
        style={{ 
          background: 'none', 
          border: 'none', 
          color: "#222B60", 
          cursor: "pointer", 
          textDecoration: "underline",
          padding: 0,
          font: 'inherit'
        }}
        type="button"
      >
        {text}
      </button>
  )
}

export default SkipButton